// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-sonner-toast][data-styled='true'].oplus-toast {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 180px;
  height: 60px;
  padding: 8px;
  border-radius: 5px;
  border: none;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  font-size: 15px;
}
[data-sonner-toast][data-styled='true'][data-x-position='center'].oplus-toast {
  left: 50%;
  right: auto;
  transform: translateX(-50%) var(--y);
}
[data-sonner-toast][data-styled='true'] [data-icon].oplus-toast-icon {
  margin: 0;
  width: 16px;
  height: 16px;
}
[data-sonner-toast][data-styled='true'] [data-icon].oplus-toast-icon svg {
  width: 16px;
  height: 16px;
  color: #fff;
}
[data-sonner-toast][data-styled='true'] [data-title].oplus-toast-title {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
}
[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close {
  top: 6px;
  right: 6px;
  transform: none;
  width: 16px;
  height: 16px;
  background: transparent;
  border: none;
  color: #fff;
  opacity: 0.5;
}
[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close:hover {
  opacity: 1;
}
[data-sonner-toast][data-styled='true']:hover [data-close-button].oplus-toast-close:hover {
  background: transparent;
  border-color: transparent;
}
[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close svg {
  width: 16px;
  height: 16px;
}
[data-sonner-toast][data-styled='true'].oplus-toast-success {
  background: #39aedf;
}
[data-sonner-toast][data-styled='true'].oplus-toast-error {
  background: #fa7a7af7;
}
[data-sonner-toast][data-styled='true'].oplus-toast-info {
  background: #5f6b71f7;
}
[data-sonner-toaster][data-y-position='bottom'][data-x-position='center'] {
  --offset-bottom: 60px;
  --mobile-offset-bottom: 60px;
}
[data-sonner-toast][data-styled='true'].save-success-toast {
  flex-direction: row;
  gap: 20px;
  width: 270px;
  height: 78px;
  padding: 12px;
  border-radius: 8px;
  background: #32b643;
}
[data-sonner-toast][data-styled='true'].save-success-toast [data-icon].oplus-toast-icon,
[data-sonner-toast][data-styled='true'].save-success-toast [data-icon].oplus-toast-icon svg {
  width: 54px;
  height: 54px;
}
[data-sonner-toast][data-styled='true'].save-success-toast [data-title].oplus-toast-title {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/vue/components/Toast.vue"],"names":[],"mappings":";AA2BA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,eAAe;AACjB;AAEA;EACE,SAAS;EACT,WAAW;EACX,oCAAoC;AACtC;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AAEA;EACE,UAAU;AACZ;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;AAEA;EACE,eAAe;AACjB","sourcesContent":["<script setup lang=\"ts\">\nimport { Toaster } from \"vue-sonner\";\nimport \"vue-sonner/style.css\";\n</script>\n\n<template>\n  <Toaster\n    position=\"top-center\"\n    close-button\n    close-button-position=\"top-right\"\n    :duration=\"1000\"\n    :toast-options=\"{\n      classes: {\n        toast: 'oplus-toast',\n        title: 'oplus-toast-title',\n        description: 'oplus-toast-description',\n        icon: 'oplus-toast-icon',\n        closeButton: 'oplus-toast-close',\n        success: 'oplus-toast-success',\n        error: 'oplus-toast-error',\n        info: 'oplus-toast-info',\n      },\n    }\"\n  />\n</template>\n\n<style>\n[data-sonner-toast][data-styled='true'].oplus-toast {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 180px;\n  height: 60px;\n  padding: 8px;\n  border-radius: 5px;\n  border: none;\n  color: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  font-size: 15px;\n}\n\n[data-sonner-toast][data-styled='true'][data-x-position='center'].oplus-toast {\n  left: 50%;\n  right: auto;\n  transform: translateX(-50%) var(--y);\n}\n\n[data-sonner-toast][data-styled='true'] [data-icon].oplus-toast-icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n[data-sonner-toast][data-styled='true'] [data-icon].oplus-toast-icon svg {\n  width: 16px;\n  height: 16px;\n  color: #fff;\n}\n\n[data-sonner-toast][data-styled='true'] [data-title].oplus-toast-title {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: center;\n}\n\n[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close {\n  top: 6px;\n  right: 6px;\n  transform: none;\n  width: 16px;\n  height: 16px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  opacity: 0.5;\n}\n\n[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close:hover {\n  opacity: 1;\n}\n\n[data-sonner-toast][data-styled='true']:hover [data-close-button].oplus-toast-close:hover {\n  background: transparent;\n  border-color: transparent;\n}\n\n[data-sonner-toast][data-styled='true'] [data-close-button].oplus-toast-close svg {\n  width: 16px;\n  height: 16px;\n}\n\n[data-sonner-toast][data-styled='true'].oplus-toast-success {\n  background: #39aedf;\n}\n\n[data-sonner-toast][data-styled='true'].oplus-toast-error {\n  background: #fa7a7af7;\n}\n\n[data-sonner-toast][data-styled='true'].oplus-toast-info {\n  background: #5f6b71f7;\n}\n\n[data-sonner-toaster][data-y-position='bottom'][data-x-position='center'] {\n  --offset-bottom: 60px;\n  --mobile-offset-bottom: 60px;\n}\n\n[data-sonner-toast][data-styled='true'].save-success-toast {\n  flex-direction: row;\n  gap: 20px;\n  width: 270px;\n  height: 78px;\n  padding: 12px;\n  border-radius: 8px;\n  background: #32b643;\n}\n\n[data-sonner-toast][data-styled='true'].save-success-toast [data-icon].oplus-toast-icon,\n[data-sonner-toast][data-styled='true'].save-success-toast [data-icon].oplus-toast-icon svg {\n  width: 54px;\n  height: 54px;\n}\n\n[data-sonner-toast][data-styled='true'].save-success-toast [data-title].oplus-toast-title {\n  font-size: 14px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
